/* eslint-disable */
// 分时数据
const state = {
  m_data: {
    data: [],
    yestclose: ''
  }
}

// getters
const getters = {
  m_data: state => state.m_data,
}

// actions
const actions = {

}

// mutations
const mutations = {
  setMData(state, data) {
    state.m_data = data;
  },
  changeMData(state, data) {
    let md = JSON.parse(JSON.stringify(state.m_data))
    let ndArr = data.data
    ndArr.map((v, i) => {
      let md_index = null
      md.data.find((dv, di) => {
        if(v[0] === dv[0]) {
          md_index = di
          return di
        }
      })
      if(md_index !== null) {
        md.data[md_index] = v
      }
    })
    state.m_data = md
  },
  clearMData(state) {
    state.m_data = {
      data: [],
      yestclose: ''
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
